<div class="mapping-selector flex__box flex__box--row">
  <div class="col-sm-6 select-field-box flex__box flex__box--column">
    <div class="header-select-field-box">Available</div>

    <div class="search-input">
      <input type="text" name="filterText" [(ngModel)]="filterText" class="form-control" placeholder="Search" />
    </div>

    <div class="select-field-list">
      <div *ngFor="let group of sources" class="group-container">
        <div class="group-header d-flex justify-content-between align-items-center" (click)="toggleGroup(group.Key)">
          <div class="d-flex align-items-center">
            <i class="fa"
               [ngClass]="(expandedGroups[group.Key] || filterText) ? 'fa-chevron-down' : 'fa-chevron-right'">
            </i>
            <span style='margin-left: 8px;'>{{ group.Key }}</span>
          </div>
          <img src="/img/general-icons/plusIcon.svg" (click)="addAllFromGroup($event, group)" style="cursor: pointer" />
        </div>

        <div *ngIf="expandedGroups[group.Key] || filterText">
          <div *ngFor="let child of group.children | filter: 'Key' : filterText"
               class="field-stroke d-flex justify-content-between align-items-center"
               [class.already-mapped]="isMapped(child)">
            <span class="field-name">{{ child.Key.split('.').slice(1).join('.') || child.Key }}</span>
            <img src="/img/general-icons/plusIcon.svg" (click)="addMapping(child)" *ngIf="!isMapped(child)" style="cursor: pointer" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-6 selected-fields-box flex__box flex__box--column">
    <div class="header-selected-fields-box d-flex justify-content-between align-items-center">
      <span>Mapped</span>
      <button type="button" class="button ND--buttons--second-button" (click)="removeAll()">Remove All</button>
    </div>
    <div class="select-field-list">
      <div *ngFor="let item of selectedValues" class="selected-field-stroke d-flex justify-content-between align-items-center">
        <span class="selected-field-name">{{ item.Key }}</span>
        <i class="fa fa-times" (click)="removeMapping(item)" style="cursor: pointer"></i>
      </div>
    </div>
  </div>
</div>
